// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__8qeEE","radioRow":"SimpleQuestionBuilderModal_radioRow__2U8LQ"};